import withStripePayment from "./withStripePayment";
export {withStripePayment}